/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopNav_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopAppliedFilters_itemSearch" | "SbRespSortItems_itemSearch" | "SbRespPageSize_itemSearch" | "SbRespRefineTopFilters_itemSearch" | "SbSharedRefineMenuSearchWithin_itemSearch" | "SbRespRefineMenuDrawer_itemSearch">;
    readonly " $refType": "SbRespRefineTopNav_itemSearch";
};
export type SbRespRefineTopNav_itemSearch$data = SbRespRefineTopNav_itemSearch;
export type SbRespRefineTopNav_itemSearch$key = {
    readonly " $data"?: SbRespRefineTopNav_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopNav_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopNav_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespPageSize_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopFilters_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuSearchWithin_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '56d6e0235fd62019fe134633eb457050';
export default node;
